export const NPS_NEGATIVE_REASON_TAGS = [
  { value: 'korean-usage' },
  { value: 'pronunciation' },
  { value: 'time' },
  { value: 'content' },
  { value: 'noise' },
  { value: 'attitude' },
  { value: 'feedback' },
  { value: 'topic' },
  { value: 'other' },
] as const

export const NPS_POSITIVE_REASON_TAGS = [
  { value: 'pace' },
  { value: 'grammar' },
  { value: 'pronunciation' },
  { value: 'expression' },
  { value: 'fun' },
  { value: 'attitude' },
  { value: 'other' },
] as const

// 별점 기준 분기 (PRD §3.8):
// - 1~2★: 부정 칩 + 차단 옵트인
// - 3★  : 부정 칩 + 옵트인 없음(중립)
// - 4~5★: 긍정 칩 + 찜 옵트인
// 즉 칩은 "4★ 이상만 긍정", 차단 옵트인은 "2★ 이하", 찜 옵트인은 "4★ 이상".
export const NPS_LOW_RATING_THRESHOLD = 2
export const NPS_HIGH_RATING_THRESHOLD = 4

export const STAR_COLORS = {
  on: '#B5FD4C',
  off: '#E7E7E7',
  stroke: '#1C1C1C',
} as const
